var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('div',{staticClass:"survey-card-bg"}),(!_vm.$router.history.current.meta.isPublic)?_c('admin-header',{staticClass:"m-b-30",class:{ 'list-header' : _vm.$router.history.current.name === 'SurveyAdmin' }}):_vm._e(),_c('div',{attrs:{"id":"inner-content"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }